import React from 'react';
import { render, fireEvent } from '@testing-library/react';

import EventRow from './EventRow';

describe('EventRow', () => {
  const baseEvent = {
    '@id': 'evt-001',
    '@timestamp': '2026-03-28T14:30:00.000Z',
    Level: 'ERROR',
    controller: 'CasesController',
    action: 'show',
    message: 'Something went wrong in the case lookup',
    method: 'GET',
    status: '500',
    path: '/cases/123',
  };

  const defaultProps = {
    event: baseEvent,
    isAnchor: false,
    isError: false,
    index: 0,
  };

  const renderEventRow = (props = {}) =>
    render(<EventRow {...defaultProps} {...props} />);

  it('renders timestamp, level, controller#action, and message', () => {
    const { getByText } = renderEventRow();

    expect(getByText('2026-03-28 14:30:00.000')).toBeInTheDocument();
    expect(getByText('ERROR')).toBeInTheDocument();
    expect(getByText('CasesController#show')).toBeInTheDocument();
    expect(
      getByText('Something went wrong in the case lookup'),
    ).toBeInTheDocument();
  });

  it('shows ANCHOR tag when isAnchor is true', () => {
    const { getByText } = renderEventRow({ isAnchor: true });

    expect(getByText('ANCHOR')).toBeInTheDocument();
  });

  it('does not show ANCHOR tag when isAnchor is false', () => {
    const { queryByText } = renderEventRow({ isAnchor: false });

    expect(queryByText('ANCHOR')).not.toBeInTheDocument();
  });

  it('expands to show event JSON when clicked', () => {
    const { getByRole, getByText, queryByText } = renderEventRow();

    expect(queryByText('Event JSON')).not.toBeInTheDocument();

    fireEvent.click(getByRole('button'));

    expect(getByText('Event JSON')).toBeInTheDocument();
  });

  it('shows backtrace section when event has backtrace', () => {
    const eventWithBacktrace = {
      ...baseEvent,
      backtrace: [
        'app/controllers/cases_controller.rb:42',
        'lib/middleware/error_handler.rb:15',
      ],
    };

    const { getByRole, getByText } = renderEventRow({
      event: eventWithBacktrace,
    });

    fireEvent.click(getByRole('button'));

    expect(getByText('Backtrace')).toBeInTheDocument();
    expect(
      getByText(
        (content, element) =>
          element.tagName === 'PRE' &&
          content.includes('app/controllers/cases_controller.rb:42'),
      ),
    ).toBeInTheDocument();
  });
});
